var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('div',_vm._l((_vm.socialItems()),function(item){return _c('v-btn',{key:item.icon,staticClass:"v-btn v-btn--icon",on:{"click":function($event){return _vm.openLink(item.link)}}},[_c('font-awesome-icon',{staticClass:"social-button",attrs:{"dark":"","icon":{ prefix: 'fab', iconName: item.icon }}})],1)}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b364ddf2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Social.vue
// module id = 622
// module chunks = 0